import { type ASSET_TYPES_ENUM } from 'types/asset.types';
import BaseAPI from './base.api';

export default class GeoAPI extends BaseAPI {
  getTrips = async (
    deviceId: string,
    startDateTime: string,
    endDateTime: string
  ) => {
    const response = await this.API.get('geo/gpsTrips', {
      params: {
        deviceId,
        startDateTime,
        endDateTime,
      },
    });
    return response.data;
  };

  getAssetTypeTrips = async (
    startDateTime: string,
    endDateTime: string,
    isShiftWise: boolean
  ) => {
    const response = await this.API.get('geo/gpsTripsByAssetTypes', {
      params: {
        startDateTime,
        endDateTime,
        isShiftWise,
      },
    });
    return response.data;
  };

  getAssetTypeTripsDateRange = async (
    tripStartTime: string,
    tripEndTime: string
  ) => {
    const response = await this.API.get('geo/gpsTripsByAssetTypesDateRange', {
      params: {
        tripStartTime,
        tripEndTime,
      },
    });
    return response.data;
  };

  getLatestTripsByFleetAssets = async () => {
    const response = await this.API.get('geo/gpsFleetLatestTripsByAsset');
    return response.data;
  };

  getDynamicPits = async (startDate?: string, endDate?: string) => {
    const response =
      startDate && endDate
        ? await this.API.get('geo/loading-unloading-areas', {
            params: {
              startDate,
              endDate,
            },
          })
        : await this.API.get('geo/loading-unloading-areas');
    return response.data;
  };

  getDeviceGpsDataPerTime = async (
    startDate: string,
    endDate: string,
    deviceId: string,
    assetType: string
  ) => {
    const response = await this.API.get('geo/deviceLocationPerTimeRange', {
      params: {
        startDate,
        endDate,
        deviceId,
        assetType,
      },
    });
    return response.data;
  };

  getDeviceAllGpsDataPerTime = async (
    dataPoints: Array<{
      device_id: string;
      start_ts: string;
      end_ts: string;
      asset_type: ASSET_TYPES_ENUM;
    }>
  ) => {
    const response = await this.API.post('geo/deviceAllLocationsPerTimeRange', {
      dataPoints,
    });
    return response.data;
  };

  getGeoHashTrips = async (
    device: string,
    tripDate: string,
    isProductive: boolean
  ) => {
    const response = await this.API.get('geo/geohash-routes', {
      params: {
        device,
        tripDate,
        isProductive,
      },
    });
    return response.data;
  };

  addUpdateGeoHashTrips = async (data: any) => {
    const response = await this.API.post('geo/geohash-routes', data);
    return response.data;
  };
}
